// NOTE: this should be combined with RBSelectField.js but there are some special cases.
// this seems to only be used with filter bars in claims and HCSA so renamed the
// component appropriatly to be clearer on what this does (MA)

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'

import { Colors } from '../theme'

class FilterDropdownMenu extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.resetState = this.resetState.bind(this)
    let defaultValue = props.defaultText ? 0 : props.data[0]
    this.state = {
      value: defaultValue
    }
    // save a copy
    this.baseState = this.state
  }

  handleChange (event, index) {
    const value = index.props.value
    this.setState({ value })
    this.props.sendValues({ [this.props.id]: value })
  }

  resetState () {
    const self = this
    this.setState({ ...self.baseState })
  }

  render () {
    const props = this.props
    const data = props.data
    const defaultText = props.defaultText || null

    const val = props.selected ? props.selected : this.state.value

    return (
      <FormControl style={{ width: props.fullWidth ? '100%' : 'auto' }}>
        <InputLabel
          htmlFor={props.id}
          error={!!props.errorText}
          style={{
            color: Colors.Palette.primaryTextColor
          }}
        >{props.label}</InputLabel>
        <Select
          id={this.props.id}
          value={val === 'All' ? 0 : val}
          onChange={this.handleChange}
          ref={(input) => { this.select = input }}
          style={{ width: props.fullWidth ? '100%' : 'auto' }}
          error={!!props.errorText}
        >
          {defaultText && <MenuItem key={0} value={0}>{defaultText}</MenuItem>}
          {data && data.map((item, i) => { return <MenuItem key={i + 1} value={item && item.id}>{item && item.text}</MenuItem> })}

        </Select>
        <FormHelperText error={!!props.errorText}>{props.errorText}</FormHelperText>
      </FormControl>
    )
  }
}

FilterDropdownMenu.propTypes = {
  data: PropTypes.array,
  defaultText: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  sendValues: PropTypes.func
  // selected: PropTypes.number
}

export default FilterDropdownMenu



// WEBPACK FOOTER //
// ./src/controls/FilterDropdownMenu.js